import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { DesignerContextType } from '../../types/designer-context-type';
import { BaseDesignerComponent } from '../designers/base/base-designer-component';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'sx-designer-menu',
  templateUrl: './designer.menu.component.html'
})
export class SxDesignerMenuComponent {
  @Input() designerContext: DesignerContextType;
  @Input() lastActiveDesigner: any;
  @Output() showDesignerConfig: EventEmitter<any> = new EventEmitter();
  _lastActiveViewEngine: any;

  // Referencia al menu de designers ( editar/ cerrar)
  @ViewChild('designerMenuElement', { read: ViewContainerRef })
  private designerMenuElement: ViewContainerRef;

  constructor(public ngxSmartModalService: NgxSmartModalService) {}

  showModal() {
    if(this.designerContext.selectedDesigner) {
      if(this.designerContext.selectedDesigner.type === 'SxViewEngine') {
        this._lastActiveViewEngine = this.designerContext.selectedDesigner;
        this.ngxSmartModalService.setModalData({}, 'viewEngineModal');
        this.ngxSmartModalService.getModal('viewEngineModal').open();
      } else {
        this.showDesignerConfig.emit();
      }
    } else if(this.designerContext.selectedDesigner == null && this._lastActiveViewEngine != null) {
      this.designerContext.selectedDesigner = this._lastActiveViewEngine;
      this.ngxSmartModalService.getModal('viewEngineModal').open();
    }
  }

  // Remueve el designer seleccionado
  removeCurrentDesigner(): void {
    this.removeDesignerMenu();
    if (!this.designerContext.selectedDesigner) {
      return;
    }

    const designer = this.designerContext.selectedDesigner;
    // borro el control
    this.designerContext.designers[designer.id].destroy();
    this.designerContext.selectedDesigner = null;
  }

  removeDesignerMenu(): void {
    this.designerMenuElement.element.nativeElement.style.display = 'none';
    if (this.lastActiveDesigner !== undefined) {
      this.lastActiveDesigner.classList.remove('active');
    }
  }

  // positions the designer menu
  designerShowMenu(designer: BaseDesignerComponent): void {
    if (!designer) {
      return;
    }

    this.designerContext.selectedDesigner = designer;
    this.designerContext.selectedDesignerAtts = designer.attributes;
    const designerElement = designer.container.nativeElement.firstChild;

    if (this.lastActiveDesigner === undefined) {
      this.lastActiveDesigner = designerElement;
    }

    if (designerElement !== this.lastActiveDesigner) {
      this.lastActiveDesigner.classList.remove('active');
      this.lastActiveDesigner = designerElement;
    }

    const rect = designerElement.getBoundingClientRect();
    const pos = this.cumulativeOffset(designerElement);

    pos.top = pos.top - window.pageYOffset - 94;
    pos.left = rect.x + rect.width - 455;

    this.designerMenuElement.element.nativeElement.style.display = 'block';
    this.designerMenuElement.element.nativeElement.style.position = 'absolute';
    this.designerMenuElement.element.nativeElement.style.left = pos.left + 'px';
    this.designerMenuElement.element.nativeElement.style.top = pos.top + 'px';

    designerElement.classList.add('active');
  }

  cumulativeOffset(element): any {
    let top = 0,
      left = 0;
    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);

    return {
      top: top,
      left: left
    };
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/main/designer.menu.component.ts